export default "/resources";
